module.exports = __webpack_public_path__ + "img/biote-logo.840443b9.png";